import { motion } from "framer-motion";
import { LINKS, IMAGES } from "@/lib/constants";

export default function Gallery() {
  return (
    <section id="galerie" className="py-28 lg:py-36" style={{ background: "#111111" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="pre-headline mb-6">
          Galerie
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl mb-16"
          data-testid="gallery-headline"
        >
          Unsere Arbeit <span className="gold-text">spricht für sich.</span>
        </motion.h2>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
          {IMAGES.gallery.map((src, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="gallery-item break-inside-avoid"
              data-testid={`gallery-item-${i}`}
            >
              <img src={src} alt={`Nabil Barbershop Arbeit ${i + 1}`} loading="lazy" />
              <div className="overlay">
                <span className="text-xs uppercase" style={{ letterSpacing: "2px", color: "#E8CC7A" }}>Nabil Barbershop</span>
              </div>
              <div className="frame" />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-14 text-center"
        >
          <a href={LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="btn-ghost" data-testid="gallery-tiktok-cta">
            Folge uns auf TikTok @nabil_barbershop
          </a>
        </motion.div>
      </div>
    </section>
  );
}
